import { axiosInstance } from "../../../api/axiosInstance";
import { StaffAbsenteesByDept } from "../../../modules/common/shared/apis/StaffAPI";
import { Dashboard, GradesDue } from "../../../modules/common/shared/types";
import { AttendanceByGrade, AttentionItem, AttentionSeverity, DailyFeeTrend, FacultyAttendance, FeeByGrade, MonthlyFeeTrend } from "../types";
import { AdminDashboardResponse } from "../types/admin-dashboard.types";
import { attentionItemCatalog } from "./attentionCatalog";

export const dashboardService = {
  mapBackendToAttendance(data: [{ grade: string; sections: [{ name: string; total: number }] }]): AttendanceByGrade[] {
    return data.map(({ grade, sections }) => ({
      grade,
      sections,
    }));
  },

  async getDashboardData(): Promise<AdminDashboardResponse> {
    console.log(">>> AxiosAPI::getDashboardData");

    try {
      let dashboardData: Dashboard = (await axiosInstance.get("/dashboard")).data;
      let adminDashboardResponse: AdminDashboardResponse = {
        studentOverview: {
          totalStudents: 0,
          activeStudents: 0,
          admissionsInProgress: undefined,
          attendanceToday: undefined,
        },
        feeOverview: {
          collected: 0,
          currentYearDues: 0,
          previousYearDues: 0,
        },
        feeByGrade: [],
        dailyFeeTrend: [],
        monthlyFeeTrend: [],
        studentAttendanceByGrade: [],
        facultyAttendanceByCategory: [],
        attentionItems: []
      };

      const admissionsInProgressV = dashboardData.activeAdmissions;
      const attendanceTodayV = "--%";
      adminDashboardResponse.studentOverview = {
        totalStudents: dashboardData.totalStudents,
        admissionsInProgress: admissionsInProgressV,
        attendanceToday: attendanceTodayV,
        activeStudents: dashboardData.activeStudents
      };
      adminDashboardResponse.feeOverview = {
        collected: dashboardData.totalFeesCollected,
        currentYearDues: dashboardData.totalFeeDues,
        previousYearDues: dashboardData.previousTotalDue,
      };
      let gradesDues: GradesDue[] = dashboardData.feesAndDuesByGrade;
      adminDashboardResponse.feeByGrade = gradesDues.map(
        (entry): FeeByGrade => ({ grade: entry.gradeNumericalValue, collected: entry.sumOfFees, due: entry.sumOfDues })
      );

      adminDashboardResponse.monthlyFeeTrend = dashboardData.monthlyFeeCollection.map(
        (entry): MonthlyFeeTrend => ({
          month: entry.monthShortName,
          collected: Number.parseInt(entry.sumOfFee),
          discount: Number.parseInt(entry.sumOfDiscount),
        })
      );

      adminDashboardResponse.dailyFeeTrend = dashboardData.dailyFeeCollection.map(
        (entry): DailyFeeTrend => ({ day: entry.day, collected: Number.parseInt(entry.sumOfFee) })
      );

      if (dashboardData.absenteesByGrade?.length > 0)
        adminDashboardResponse.studentAttendanceByGrade = this.mapBackendToAttendance(dashboardData.absenteesByGrade);

      if (dashboardData.facultyAbsenteesByDept?.length > 0)
        adminDashboardResponse.facultyAttendanceByCategory = dashboardData.facultyAbsenteesByDept;

      if (dashboardData.attentionItems?.length > 0) {
        adminDashboardResponse.attentionItems = dashboardData.attentionItems
          .filter((item) => attentionItemCatalog[item.id])
          .map(
            (item): AttentionItem => ({
              id: item.id,
              severity: item.attentionSeverity as AttentionSeverity,
              metric: item.metric,
              ...attentionItemCatalog[item.id],
            })
          );
      }

      return Promise.resolve(adminDashboardResponse);
    } catch (e) {
      console.log(e);
    }
  },
};
